// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn__get--token[data-v-7f784b70] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: none;\n    padding-top: 5px;\n    padding-inline: 10px;\n    background-color: transparent;\n}\n.btn__get--token--icon[data-v-7f784b70] {\n    font-size: 20px;\n    color: #858585;\n    opacity: 0.9;\n}\n.btn__get--token--icon[data-v-7f784b70]:hover {\n    opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
